import React from "react";
import Button from "../Button";
import SimpleModal from "./SimpleModal";
import { Copy, Download } from "lucide-react";
import { toast } from "react-toastify";
import {
  Title,
  SubLabel,
  BackupCodeContainer,
  BackupCodeText,
  IconButton,
} from "./styles";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  backupCode: string;
}

const SuccessModal: React.FC<Props> = ({ isOpen, toggle, backupCode }) => {
  const handleCopyBackupCode = () => {
    try {
      navigator.clipboard.writeText(backupCode);
      toast.success("Código copiado al portapapeles");
    } catch (error) {
      toast.error("Error al copiar el código");
    }
  };

  const handleDownloadBackupCode = () => {
    try {
      const fileName = "codigo_de_respaldo_legales.txt";
      const element = document.createElement("a");
      const file = new Blob(
        [
          `Código de Respaldo - Legales\n\nCódigo: ${backupCode}\n\nGuarda este código en un lugar seguro. Lo necesitarás si pierdes el acceso a tu aplicación de autenticación.\n\nGenerado: ${new Date().toLocaleString()}`,
        ],
        { type: "text/plain" }
      );
      element.href = URL.createObjectURL(file);
      element.download = fileName;
      element.click();
      URL.revokeObjectURL(element.href);
      toast.success("Código descargado");
    } catch (error) {
      toast.error("Error al descargar el código");
    }
  };

  return (
    <SimpleModal isOpen={isOpen} onClose={toggle} title="" size="md">
      <div style={{ padding: "24px" }} className="modal-content-responsive">
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#10b981",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 20 20"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <Title>¡Autenticación configurada exitosamente!</Title>
        </div>

        <SubLabel style={{ marginBottom: "16px", textAlign: "center" }}>
          Tu cuenta ahora está protegida con autenticación de dos factores.
        </SubLabel>

        <div
          style={{
            backgroundColor: "#fef3c7",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
            border: "1px solid #fbbf24",
          }}
        >
          <h5
            style={{
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#92400e",
            }}
          >
            ⚠️ Importante: Guarda tu código de respaldo
          </h5>
          <SubLabel style={{ marginBottom: "12px", color: "#92400e" }}>
            Este es tu código de respaldo. Úsalo para recuperar el acceso a tu
            cuenta si pierdes tu teléfono o aplicación de autenticación.
          </SubLabel>

          <BackupCodeContainer>
            <BackupCodeText>{backupCode || "Código no disponible"}</BackupCodeText>
            <div>
              <IconButton
                type="button"
                onClick={handleCopyBackupCode}
                title="Copiar código"
              >
                <Copy size={20} color="#0066cc" />
              </IconButton>
              <IconButton
                type="button"
                onClick={handleDownloadBackupCode}
                title="Descargar código"
              >
                <Download size={20} color="#0066cc" />
              </IconButton>
            </div>
          </BackupCodeContainer>
        </div>

        <SubLabel style={{ textAlign: "center", fontSize: "11px" }}>
          A partir de ahora, necesitarás ingresar un código de tu aplicación de
          autenticación cada vez que inicies sesión.
        </SubLabel>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "0 24px 24px",
        }}
        className="modal-footer-responsive"
      >
        <Button
          type="button"
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={toggle}
        >
          Finalizar
        </Button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .modal-content-responsive {
            padding: 16px !important;
          }
          .modal-footer-responsive {
            padding: 0 16px 16px !important;
          }
          .modal-footer-responsive button {
            width: 100%;
          }
        }
      `}</style>
    </SimpleModal>
  );
};

export default SuccessModal;
